import React, { useCallback, useEffect } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/lottie/price_pot_center.json';
import clsx from 'clsx';
import styles from "./styles.module.css";
import { useSelector } from 'react-redux';
import { getCoinAnimation } from '../../../store/selectors/ludoboardSelectors';
import { getEventProcessor } from '../../../pages/GamePlay/eventProcessor';
import { getWidth } from '../../../utils/relativeSizes';

function CoinAnimation() {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const coinAnimation = useSelector(getCoinAnimation);

  const handleAnimationEnd = useCallback(() => {
    getEventProcessor()?.handleCoinAnimationEnd();
  }, []);

  if (!coinAnimation) {
    return null;
  }

  return (
    <div className={clsx(styles.lottieContainer)}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.60)',
        zIndex: 1000,
      }}
    >
      <Lottie
        options={defaultOptions}
        isPaused={false}
        isStopped={false}
        eventListeners={[
          {
            eventName: 'complete',
            callback: handleAnimationEnd,
          },
        ]}
        height="100%"
        width="100%"
      />
    </div>
  );
}

export default CoinAnimation;
